module.exports = __webpack_public_path__ + "media/de-7ded7369.mp4";